import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Eyebrow, Divider } from "@/components/site/primitives";
import { IMAGES } from "@/i18n";

const IMG_AFTER = { 0: IMAGES.storyCards1, 2: IMAGES.cards3 };

export const Story = () => {
  const { t } = useLang();
  const chapters = t.story?.chapters || [];

  return (
    <section className="relative py-24 sm:py-32 bg-espresso/30 border-y border-gold/10" data-testid="story-section">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center mb-16">
          <Eyebrow>{t.story?.eyebrow}</Eyebrow>
          <Divider className="mt-6" />
        </Reveal>

        <div className="space-y-20">
          {chapters.map((c, i) => (
            <div key={i}>
              <Reveal>
                <div className="flex items-baseline gap-4 mb-5">
                  <span className="font-display text-gold/80 text-3xl leading-none">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display font-light text-sand text-3xl sm:text-4xl leading-[1.05]">{c.title}</h3>
                </div>
              </Reveal>
              <div className="space-y-4 pl-0 sm:pl-12">
                {c.paragraphs.map((p, j) => (
                  <Reveal key={j} delay={0.05}>
                    <p className="text-sand/75 text-base sm:text-lg leading-relaxed font-light">{p}</p>
                  </Reveal>
                ))}
              </div>

              {IMG_AFTER[i] && (
                <Reveal className="mt-14">
                  <div className="relative overflow-hidden rounded-2xl border border-gold/20">
                    <img src={IMG_AFTER[i]} alt="" className="w-full h-[280px] sm:h-[360px] object-cover" />
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ivy/50 to-transparent" />
                  </div>
                </Reveal>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Story;
